export class GitEnvVariables {
    branch: string;
    pipelineUrl; string;
    envName: string
    versionHash: string;
}